// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4a201af0","455":"a814cfbd","977":"6411a0fd"}[chunkId] + ".chunk.js";
};